import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const CheckboxWrapper = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  user-select: none;
  width: fit-content;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
`;

export const StyledCheckbox = styled.div<{ $checked: boolean; $variant: string; $size: string; $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $size }) => ($size === 'sm' ? '16px' : $size === 'lg' ? '24px' : '20px')};
  height: ${({ $size }) => ($size === 'sm' ? '16px' : $size === 'lg' ? '24px' : '20px')};
  background: ${({ theme, $checked, $disabled }) =>
        $disabled ? theme.colors.gray200 : ($checked ? theme.colors.primary : theme.colors.surface)};
  border: 2px solid ${({ theme, $checked, $variant, $disabled }) =>
        $disabled ? theme.colors.gray300 : ($variant === 'error' ? theme.colors.error : ($checked ? theme.colors.primary : theme.colors.gray300))};
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  transition: all 0.2s ease-in-out;

  &:after {
    content: '';
    width: ${({ $size }) => ($size === 'sm' ? '4px' : $size === 'lg' ? '8px' : '6px')};
    height: ${({ $size }) => ($size === 'sm' ? '8px' : $size === 'lg' ? '14px' : '10px')};
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg) translate(-1px, -1px);
    display: ${({ $checked }) => ($checked ? 'block' : 'none')};
  }

  ${HiddenCheckbox}:focus-visible + & {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.background},
                0 0 0 4px ${({ theme }) => theme.colors.primary};
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme, $checked, $disabled }) =>
        !$disabled && !$checked ? theme.colors.primaryLight : 'inherit'};
  }
`;

export const Label = styled.span<{ $disabled?: boolean }>`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme, $disabled }) => ($disabled ? theme.colors.textDisabled : theme.colors.text)};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
`;

export const ErrorMessage = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.error};
`;

export const HelperText = styled.span`
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  color: ${({ theme }) => theme.colors.textSecondary};
`;
